import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ParametrosSolitudServiciosEntity, TipoReporte } from 'src/app/services/servicio-solicitud-servicios.service';
import {
  ServicioSolitudServiciosService,
  ReporteOrdenMedicasFiltro
} from 'src/app/services/servicio-solicitud-servicios.service';
import { ProcedimientoEntity } from 'src/app/interfaces/procedimiento';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-header-orden-medica',
  templateUrl: './header-orden-medica.component.html',
  styleUrls: ['./header-orden-medica.component.css']
})
export class HeaderOrdenMedicaComponent implements OnInit {

  @Input() parametros: ParametrosSolitudServiciosEntity;
  @Input() isHistoria: boolean;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  filtros: ReporteOrdenMedicasFiltro = {} as ReporteOrdenMedicasFiltro;
  procedimientos: SelectItem[] = [];
  procedimientosSelected = [];

  tipoReporte: SelectItem[] = [];
  tipoReporteSelected = TipoReporte.SOLO_HISTORIA;

  constructor(private servicioSolicitudServ: ServicioSolitudServiciosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();

    this.filtros.discriminarNoPos = false;
    this.filtros.discriminarServicios = false;
    this.filtros.impresionServicios = false;
    this.tipoReporte = [
      {
        value: TipoReporte.SOLO_HISTORIA,
        label: 'Solo Historia'
      },
      {
        value: TipoReporte.CONSOLIDADO,
        label: 'Consolidado Total'
      }
    ]
  }

  ngOnInit() {
    this.getProcedimientos();
  }

  async getProcedimientos() {
    let response;
    if (this.isHistoria) {
      response = await this.servicioSolicitudServ.getProcedimientosHistoria(this.parametros);
    } else {
      response = await this.servicioSolicitudServ.getProcedimientosEvolucion(this.parametros);
    }
    response.subscribe((data: ProcedimientoEntity[]) => {
      data.forEach((proc: ProcedimientoEntity) => {
        this.procedimientos.push({
          label: proc.descripcionCorta,
          value: proc.unco
        });
        this.procedimientosSelected.push(proc.unco);
      });
      this.onGenerar();
    }, (error) => {
      console.log('Error HeaderOrdenMedicaComponent.getProcedimientos()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de procedimientos, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  onGenerar() {
    const procedimientos = this.procedimientosSelected.toString();
    const tipoReporte = this.tipoReporteSelected;
    if (procedimientos.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Procedimiento</strong>.');
    } else {
      this.filtros.procedimientos = procedimientos;
      this.filtros.tipoReporte = tipoReporte;
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-ordenes-medicas').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
